import { ListItemAvatar, ListItemText } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import { Environment } from "../networking/axios";

interface IEnvironmentDigalogProps {
    selected: string
    onClose: () => void;
}

export default function EnvironmentDigalog(props: IEnvironmentDigalogProps) {
    const { selected, onClose } = props;
    const values = ["stable", "prestable", "testing", "qa"];

    const handleListItemClick = (value: string) => {
        Environment.setEnvironmentFromName(value);
        window?.location?.reload();
    };

    return (
        <Dialog onClose={onClose} open={true}>
            <DialogTitle>Choose your destiny</DialogTitle>
            <List>
                {
                    values.map(value => (
                        <ListItem button onClick={() => handleListItemClick(value)} key={value}>
                            <ListItemText primary={value} style={{ color: value == selected ? "blue" : "black" }} />
                        </ListItem>
                    ))
                }
            </List>
        </Dialog>
    );
}